import {Toast, ToastStyle} from "../ui/Toast";
import {styleRuleInherit} from "../../stem-core/src/decorators/Style";
import {registerStyle, Theme} from "../../stem-core/src/ui/style/Theme";
import {Router} from "../../stem-core/src/ui/Router";
import {EMPTY_PANEL_TYPE} from "../../blink-sdk/Constants";


class PaywallToastStyle extends ToastStyle {
    @styleRuleInherit
    toast = {
        bottom: "",
        top: 8,
        transform: "translate(-50%, -96px)",
    };
}

@registerStyle(PaywallToastStyle)
export class PaywallToast extends Toast {
    static showError(message) {
        const ERROR_OPTIONS = {style: {background: Theme.props.MERCHANT_ERROR}, showClose: true, visibleTimeout: null};
        this.show(message, ERROR_OPTIONS);
    }

    static show(...args) {
        if (Router.getCurrentPath() === "/" + EMPTY_PANEL_TYPE) {
            return;
        }
        super.show(...args);
    }

    onMount() {
        super.onMount();
        this.attachListenerOnce(Router.Global, "change", () => {
            this.constructor.hide(this)
        })
    }
}
